// -----------------------------------------------------------------
//  this function is a placeholder and is not currently in use
// -----------------------------------------------------------------


import { useContext, useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import PageContext from './PageContext';
import PageDropdown from './PageDropdownCopy';
import AutoCompleteInput from './AutoCompleteInputCopy';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from "./ButtonComponent";

const AddNewUserModal = () => {
    // get context from parent
    const {
        addNewUserModal,
        setAddNewUserModal,
        addRoleList,
    } = useContext(PageContext);
    // initialize state
    const [role, setRole] = useState('--select--');
    const [searchUser, setSearchUser] = useState('');
    // array to hold userList for autocomplete
    const userList = [];
    // event handler for submit click 
    const onSubmit = () => {
        setAddNewUserModal(addNewUserModal => addNewUserModal = false);
    }

    return (
        <>
            <CCOffcanvas className="rebate-summary-modal"
                show={addNewUserModal}
                title="Add New User"
                onCanvasClose={() => setAddNewUserModal(addNewUserModal => addNewUserModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-30"
            >   
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                        <div className="d-flex align-items-center justify-content-start">
                            <PageDropdown tag='Role' value={role} setValue={setRole} list={addRoleList} topAlignTypography={true} width={'100%'} />
                        </div>
                        <div className="d-flex align-items-center justify-content-start mt-3">
                            <AutoCompleteInput tag='Search User' value={searchUser} setValue={setSearchUser} list={userList} width={'100%'} topAlignTypography={true} />
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={'Submit'}
                            border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                            onButtonClick={() => onSubmit()}
                        />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AddNewUserModal;